import { APICONSTANTS } from '../../constants/api-constants';
import { SocieteLinkedService } from './societe-linked.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ArticleModel } from 'src/app/shared/models/societe-linked/article.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class ArticleService extends SocieteLinkedService<ArticleModel> {
  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
              super(http, toastrService, APICONSTANTS.ROUTEARTICLE, hostnameService);
  }
  
  getbyCa1(idSociete: number, idCa1: number): Observable<ArticleModel[]> {
    return this.http.get<ArticleModel[]>(
      APICONSTANTS.URLAPI.value + this.route + 'getbyCa1?idSociete=' + idSociete + '&idCa1=' + idCa1)
      .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }

  getFromCa1Categorie(idSociete: number, idCa1: number, codeCategorie: string): Observable<ArticleModel[]> {
    return this.http.get<ArticleModel[]>(
      APICONSTANTS.URLAPI.value + this.route + 'getFromCa1Categorie?idSociete=' + idSociete + '&idCa1=' + idCa1 + '&codeCategorie=' + codeCategorie)
      .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }
}
